<script setup lang="ts">
import {
  ScenarioChatForm,
  mapToScenarioChatMessageInputs,
  useScenarioChatForm,
} from '@/components/organisms/ScenarioChatForm'
import type {
  ScenarioChatFormType,
  ScenarioChatFragment,
} from '@/components/organisms/ScenarioChatForm'
import {
  useUpdateScenarioChatMutation,
  type ScenarioChatPageQuery,
} from './ScenarioChatPage.generated'
import { useAlert } from '@/libs/alertPortal'
import { onBeforeRouteLeave } from 'vue-router'
import { onMounted, onUnmounted } from 'vue'

const props = defineProps<{
  initialScenarioChat: ScenarioChatFragment
  query: ScenarioChatPageQuery
}>()

const updateScenarioChatMutation = useUpdateScenarioChatMutation()

const alert = useAlert()

const handleUpdate = async (scenarioChat: ScenarioChatFormType) => {
  await updateScenarioChatMutation.mutate({
    input: {
      guid: props.initialScenarioChat.guid,
      title: scenarioChat.title,
      messages: mapToScenarioChatMessageInputs(scenarioChat.messages),
    },
  })

  alert.success('シナリオを更新しました')
}

const form = useScenarioChatForm({
  initialScenarioChat: props.initialScenarioChat,
  query: props.query,
  onSubmit: handleUpdate,
})

onBeforeRouteLeave((_, __, next) => {
  if (form.isDirty.value) {
    if (confirm('編集内容を破棄して、このページを離れますか？')) {
      next(true)
    } else {
      next(false)
    }
    return
  }

  next(true)
})

const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  if (form.isDirty.value) {
    event.preventDefault()
  }
}

onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload)
})

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload)
})
</script>

<template>
  <ScenarioChatForm />
</template>
